export const queryKeys = {
  me: ['auth', 'me'],
  profileOptions: (locale) => ['auth', 'profile-options', String(locale || '')],
  home: ['assessment', 'home'],
  assessment: ['assessment', 'questionnaire'],
  attempt: (id) => ['assessment', 'attempt', String(id || '')],
  results: (page) => ['results', 'history', page],
  result: (id) => ['results', 'detail', String(id)],
  consultationOptions: ['consultations', 'options'],
  consultations: (page) => ['consultations', 'list', page],
  consultation: (id) => ['consultations', 'detail', String(id)],
  notifications: (page) => ['notifications', 'list', page],
  unreadCount: ['notifications', 'unread-count'],
  supportCategories: ['support', 'categories'],
  tickets: (page) => ['support', 'tickets', page],
  ticket: (id) => ['support', 'ticket', String(id)],
  legalCurrent: ['legal', 'current'],
  companyPlans: (page) => ['company', 'plans', page],
  companyPlan: (id) => ['company', 'plan', String(id || '')],
  companyBootstrap: ['company', 'bootstrap'],
  companyMembers: (page) => ['company', 'members', page],
  companyPurchases: (page) => ['company', 'purchases', page],
  companyPurchase: (id) => ['company', 'purchase', String(id || '')],
  companyCredits: ['company', 'credits'],
  companyEntitlements: ['company', 'entitlements'],
  companyCodes: (filters) => ['company', 'codes', filters],
  companyParticipants: (page) => ['company', 'participants', page],
  companyParticipantResult: (attemptId) => ['company', 'participant-result', String(attemptId || '')],
};

export function clearPrivateQueries(client) {
  if (!client) {
    return;
  }
  client.removeQueries({ queryKey: ['auth'] });
  client.removeQueries({ queryKey: ['assessment'] });
  client.removeQueries({ queryKey: ['results'] });
  client.removeQueries({ queryKey: ['consultations'] });
  client.removeQueries({ queryKey: ['notifications'] });
  client.removeQueries({ queryKey: ['support'] });
  client.removeQueries({ queryKey: ['company'] });
  client.clear();
}
